<template>
  <div class="rotation-indicator" :class="rootClasses" :style="rootStyles">
    <div class="rotation-indicator__label">
      <slot name="default" />
    </div>
    <!--
    <div class="rotation-indicator__wrapper">
      <div class="rotation-indicator__sphere">
        <div
          v-for="eulerAngleName in $options.eulerAngleNameList"
          :key="eulerAngleName"
          class="rotation-indicator__euler-angle"
          :class="[`rotation-indicator__euler-angle--${eulerAngleName}`]"
        >
          <svg
            class="rotation-indicator__circle"
            :viewBox="`0 0 ${$options.boxSize} ${$options.boxSize}`"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              :cx="$options.boxSize / 2"
              :cy="$options.boxSize / 2"
              :r="$options.largeCircleSize / 2"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
            />
            <circle
              :cx="$options.boxSize / 2"
              :cy="$options.smallCircleSize / 2"
              :r="$options.smallCircleSize / 2"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
  import bemMixin from '@/assets/js/mixin/bem'

  export default {
    mixins: [bemMixin('rotation-indicator')],
    props: {
      rotation: {
        type: Array,
        required: true,
      },
      hierarchy: {
        type: Number,
        required: true,
      },
    },
    computed: {
      rootClasses() {
        return [this.bemAdd(`hierarchy-${this.hierarchy}`)]
      },
      rootStyles() {
        return {
          '--lambda': `${this.hierarchy <= 1 ? this.rotation[0] : 0}deg`,
          '--phi': `${this.hierarchy <= 2 ? this.rotation[1] : 0}deg`,
          '--gamma': `${this.hierarchy <= 3 ? this.rotation[2] * -1 : 0}deg`,
        }
      },
    },
    eulerAngleNameList: ['lambda', 'phi', 'gamma'],
    boxSize: 32,
    largeCircleSize: 26,
    smallCircleSize: 6,
  }
</script>

<style lang="scss" src="./_rotation-indicator.scss" />
